
import { defineComponent, onMounted, computed } from "vue";
import FounderStatistics from "@/components/widgets/mixed/FounderStatistics.vue";
import InvestorStatistics from "@/components/widgets/mixed/InvestorStatistics.vue";
import ExpertStatistics from "@/components/widgets/mixed/ExpertStatistics.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";

export default defineComponent({
  name: "dashboard",
  components: {
    FounderStatistics,
    ExpertStatistics,
    InvestorStatistics
  },
  setup() {
    const store = useStore()
    const user = computed(() => store.getters.getUser)
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
    return{
      user,
    }
  },
});
